"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordTypeName = void 0;
var RecordTypeName;
(function (RecordTypeName) {
    RecordTypeName["CLIENT_APPROVAL_PROCESS"] = "Client Approval Process";
    RecordTypeName["COMPLIANCE"] = "Compliance";
    RecordTypeName["COUNTERPARTY_OVERRIDES"] = "Counterparty Overrides";
    RecordTypeName["CURRENCY_PAIR_AMENDMENT"] = "Currency Pair Amendment";
    RecordTypeName["FX_TRADING"] = "FX Trading";
    RecordTypeName["INVOICING"] = "Invoicing";
    RecordTypeName["MASTER"] = "Master";
    RecordTypeName["PAYMENTS"] = "Payments";
    RecordTypeName["REVENUE_SPLIT"] = "Revenue Split";
})(RecordTypeName = exports.RecordTypeName || (exports.RecordTypeName = {}));
